import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {logPageLoadEvents} from '@ibibo/analytics';

import * as S from './HomePage.styles';
import {updateSid} from '../../../../../onboarding/src/store/actions/thunk';
// import PopularDestinations from './containers/PopularDestinations';
import RecentSearch from './containers/RecentSearch';
import SearchBlock from './containers/SearchBlock';
import WhyUs from './containers/WhyUs';
import HotelsHomeHelmet from './containers/hotels-home-helmet';
import MyBookings from './containers/MyBookings';
import OfferCarousel from './containers/OfferCarousel';
import TopDestinations from './containers/TopDestinations';

import {fetchOffersDataThunk, fetchCamapaignDataThunk} from './redux/thunks';

import {userSettingDataSelector} from '@ibibo/myaccount-reducer';
import {useSelector} from 'react-redux';
import {useNavigateForSearchWidget} from '../../hooks/useNavigateForSearchWidget';

import SmartEngageApiContainer from '../SmartEngage/SmartEngageApiContainer';
import GoSafeCardBlock from '../SmartEngage/containers/GoSafeCardBlock';
import SmartEngageBanner from '../SRP/containers/SmartEngageBanner';
import {bannerReveal} from './redux/thunks';
import IconSelector from '@ibibo/icon-selector';

import DestinationTrending from './containers/DestinationTrending';

const HomePage = () => {
  const dispatch = useDispatch();
  const deviceWidth = window.screen.width;

  const [onSearch] = useNavigateForSearchWidget();
  const userData = useSelector(userSettingDataSelector);
  const {account_id} = userData;
  const [showPop, setShowPop] = useState(false);
  const [repetition, setRepetition] = useState(false);
  const [tabActive, setTabActive] = useState(1);

  const [banner, setBanner] = useState({url: '', cookie: ''});
  const [showVertical, setShowVertical] = useState(false);
  const [showFlightHover, setShowFlightHover] = useState(false);
  const [showHotelsHover, setShowHotelsHover] = useState(false);

  const campaignData = {
    city: userData?.city?.value,
    state: userData?.state?.value,
  };

  useEffect(() => {
    if (userData.tnc_completed) {
      if (!userData.tnc_completed.value) {
        window.open('/mysettings/', '_self');
      }
    }
  }, [userData]);

  useEffect(() => {
    fetchOffersDataThunkCaller();
    fetchCamapaignDataThunkCaller(campaignData);
  }, [campaignData]);

  const fetchOffersDataThunkCaller = useCallback(() => {
    return dispatch(fetchOffersDataThunk());
  }, [dispatch]);

  const fetchCamapaignDataThunkCaller = campaignData => {
    return dispatch(fetchCamapaignDataThunk(campaignData));
  };

  const webPushrSrc = 'pusher.js';

  useEffect(() => {
    if (account_id) {
      logPageLoadEvents('landing:domestic hotels:landing-New', {eVar67: account_id.value});
    }
  });

  useEffect(() => {
    window._webpushrScriptAttributes &&
      window.webpushr &&
      userData?.account_id?.value &&
      window._webpushrScriptAttributes({
        id: userData?.account_id?.value,
        city: userData?.city?.value,
        state: userData?.state?.value,
        pinCode: userData?.pincode?.value,
      });
  }, [userData]);

  useEffect(() => {
    if (deviceWidth < 1024) {
      window.open('/agent/mobile', '_self');
    }
  }, [deviceWidth]);

  useEffect(() => {
    const pushrKey = `(function(w,d, s, id) {if(typeof(w.webpushr)!=='undefined') return;w.webpushr=w.webpushr||function(){(w.webpushr.q=w.webpushr.q||[]).push(arguments)};var js, fjs = d.getElementsByTagName(s)[0];js = d.createElement(s); js.id = id;js.async=1;js.src = "https://cdn.webpushr.com/app.min.js";fjs.parentNode.appendChild(js);}(window,document, 'script', 'webpushr-jssdk'));webpushr('setup',{'key':'BCFslA6zpbLOEK1cGqiXdOyr7zj0-4Xc2jTMg5fYT4hxhEpnWp9HlTvZIrjbKaiycG2KvpBQAfPZmnvtJV4IoHE' });`;
    var tag = document.createElement('script');
    tag.async = false;

    tag.innerHTML = `
    function _webpushrScriptReady(){
        webpushr('fetch_id',function(sid) {
            console.log('webpushr subscriber id < debug mode > : ', sid)
        });
    }
    function _webpushrScriptAttributes(attributes){
            console.log('webpushr attributes pushed')
            if (window.webpushr){webpushr('attributes',attributes)};
        }
    ${pushrKey}
  `;

    tag.type = 'text/javascript';
    var body = document.getElementsByTagName('body')[0];
    body.insertBefore(tag, body.firstChild);

    return () => {
      document.body.removeChild(tag);
      let promptObject = document.getElementById('webpushr-prompt-wrapper');
      if (promptObject) {
        promptObject.remove();
      }
    };
  }, [webPushrSrc]);

  const closePop = () => {
    setShowPop(false);
    setCookie(banner.cookie, 'activated');
    setBanner({...banner, url: ''});
  };

  const setCookie = (cname, cvalue) => {
    var d = new Date('December 30, 2020 23:59:00');
    var expires = 'expires=' + d;
    document.cookie = cname + '=' + cvalue + ';' + expires;
  };

  const getCookie = cname => {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  //Completely disabling the pop up and the setState that might lead to re-renders
  //Will be replaced by dynamic banner handling in the future releases
  //   const offerCheck = getCookie('offerActivenewoffer');
  //   useEffect(() => {
  //     if(offerCheck === 'activated'){
  //       setShowPop(true);
  //     }else{
  //       setShowPop(true);
  //     }
  //   }, [offerCheck]);
  const bannerRevealer = async () => {
    const res = await bannerReveal();
    if (res.url && (res.url !== banner.url || res.cookieName !== banner.cookie)) {
      setBanner({cookie: res.cookieName, url: res.url});
      setRepetition(res?.repetition);
    }
  };

  useEffect(() => {
    const offerCheck = getCookie(banner.cookie);
    if (offerCheck === 'activated') {
      setShowPop(false);
    } else {
      setShowPop(true);
    }
  }, [banner.cookie]);

  useEffect(() => {
    // Empty response since it is not available at this place, and we only need to trigger the
    // sid update call. empty function call since we don't need a call back in this place
    // true is sent to trigger the update call, cause we send false currently from the login to not
    // capture the sid update. Later login will be altered to consume it differently
    dispatch(updateSid({}, status => {}, true));
  }, []);

  useEffect(() => {
    const flightShow = getCookie('mpsf');
    if (flightShow === '1') {
      setShowVertical(true);
    }
  });

  const handleSelect = index => {
    setTabActive(index);

    if (index === 0) {
      window.open('https://www.makemytrip.com/flights/', '_self');
    } else {
      window.open('https://mypartner.makemytrip.com/hotels/v1/', '_self');
    }
  };

  return (
    <>
      <S.HomePageMainWrapper>
        <HotelsHomeHelmet />
        <S.HomePageInnerWrap>
          <S.HomePageTopWrapper>
            <S.HomePageTopInnerWrap>
              {/* <S.HeadHolder></S.HeadHolder> */}

              <S.SearchWidgetWrapp>
                {(showVertical && (
                  <S.MenuIconOuterWrap>
                    <S.MenuIconInnerWrap>
                      <S.MenuWrapList>
                        <li
                          className={tabActive === 0 ? 'active' : ''}
                          onClick={() => handleSelect(0)}
                          onMouseEnter={() =>
                            tabActive === 0 ? setShowFlightHover(false) : setShowFlightHover(true)
                          }
                          onMouseLeave={() =>
                            tabActive === 0 ? setShowFlightHover(true) : setShowFlightHover(false)
                          }
                        >
                          <S.NewTag>NEW</S.NewTag>
                          <IconSelector
                            iconKey={tabActive === 0 || showFlightHover ? 'flightActive' : 'flight'}
                            props={{width: '4rem', height: '4rem', margin: '0 0 3px'}}
                          />
                          <p>Flights</p>
                        </li>
                        <li
                          className={tabActive === 1 ? 'active' : ''}
                          onClick={() => handleSelect(1)}
                          onMouseEnter={() =>
                            tabActive === 1 ? setShowHotelsHover(false) : setShowHotelsHover(true)
                          }
                          onMouseLeave={() =>
                            tabActive === 1 ? setShowHotelsHover(true) : setShowHotelsHover(false)
                          }
                        >
                          <IconSelector
                            iconKey={tabActive === 1 || showHotelsHover ? 'hotelActive' : 'hotel'}
                            props={{width: '4rem', height: '4rem', margin: '3px 0 0'}}
                          />
                          <p>Hotels</p>
                        </li>
                      </S.MenuWrapList>
                    </S.MenuIconInnerWrap>
                  </S.MenuIconOuterWrap>
                )) ||
                  null}
                <S.SearchWidgetHeadWrap>
                  <S.SearchWidgetHeadText>
                    Book Domestic & International Hotels
                  </S.SearchWidgetHeadText>

                  {/* <S.BulkBookingWrap>
      <S.SwitchWrap>
      <S.Sliderlabel for="checkbox">
      <S.SliderCheck type="checkbox" id="checkbox" />
      <S.BulkSlider></S.BulkSlider>
      </S.Sliderlabel>
      </S.SwitchWrap>
      <S.BulkBookingText>Bulk Booking (6+ Rooms)</S.BulkBookingText>
    </S.BulkBookingWrap> */}
                </S.SearchWidgetHeadWrap>

                <SearchBlock />

                <RecentSearch />

                <S.SearchBtnWrap>
                  <S.SearchBtn onClick={() => onSearch()}>SEARCH</S.SearchBtn>
                </S.SearchBtnWrap>
              </S.SearchWidgetWrapp>

              {/* <WhyUs /> */}
            </S.HomePageTopInnerWrap>
          </S.HomePageTopWrapper>

          <SmartEngageApiContainer page="home" />

          <S.HomeContentWrap>
            <OfferCarousel />

            <GoSafeCardBlock ContainerWrapper={S.GoSafeCardBlockWrapper} />

            <S.GoSafeCardBannerWrapper>
              <SmartEngageBanner page="Home" selector={0} />
            </S.GoSafeCardBannerWrapper>

            <DestinationTrending />
            <MyBookings />

            {/* <TopDestinations /> */}

            {/* <DestinationTrending /> */}

            {/* <PopularDestinations /> */}
          </S.HomeContentWrap>
        </S.HomePageInnerWrap>
      </S.HomePageMainWrapper>

      {(showPop && banner.url) || (repetition && banner.url) ? (
        <>
          <S.PopOverlay onClick={closePop}>
            <S.PopModal>
              <S.PopHeadwrap>
                {/* <S.PopupCloseBtn>
                  <IconSelector iconKey='close' />
                </S.PopupCloseBtn> */}
              </S.PopHeadwrap>
              <S.PopupBodyWrapper>
                <S.PromoImgWrap>
                  <img src={banner.url} alt="Promo Banner" />
                </S.PromoImgWrap>
              </S.PopupBodyWrapper>
            </S.PopModal>
          </S.PopOverlay>
        </>
      ) : null}
    </>
  );
};

export default HomePage;
